import React from 'react';
import { KibanaIframeLayout } from '../../components/analytics/KibanaIframeLayout';

export default () => (
    <KibanaIframeLayout
        pageName="Order Analytics"
        pageDescription="Useful insights into your customer's orders."
        dashboardId={import.meta.env.KIBANA_ORDERS_DASHBOARD_ID}
    />
);
